import { useEffect } from 'react'
import { Route, Routes, useNavigate } from 'react-router-dom';
import './App.css';
import App2 from './components/App2';
import Augest23 from './components/Augest23';
import CopiedUTR from './components/CopiedUTR';
import ExpireLink from './components/ExpireLink';
import InfoForm from './components/InfoForm';
import InfoFormBlue from './components/InfoFormBlue';
// import LoginModal from './components/Login';
import Step1 from './components/Step1';
import UTIForm from './components/UTIForm';
import UTIFormApp2 from './components/UTIFormApp2';
import AprilPage from './components/AprilPage';
import Success from './components/Success';
import Mypage from './components/Mypage';
import Payment from './components/Payment';

function App() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/");
  }, [navigate]);
  
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<div />} />
        {/* <Route path="/" element={<LoginModal />} /> */}
        <Route path="/form12" element={<UTIForm />} />
        <Route path="/form13" element={<UTIFormApp2 />} />
        <Route path="/form/:id" element={<InfoForm />} />
        <Route path="/form1/:id" element={<AprilPage />} />
        <Route path="/step1/:id" element={<Step1 />} />
        <Route path="/step2/:id" element={<InfoFormBlue />} />
        <Route path="/app2/:id" element={<App2 />} />
        <Route path="/app3/:id" element={<Augest23 />} />
        <Route path="/payment/:id" element={<Payment />} />
        <Route path="/expire" element={<ExpireLink />} />
        <Route path="/success" element={<CopiedUTR />} />
        <Route path="/utr_success" element={<Success />} />
        <Route path="/latest/:id" element={<Mypage />} />
      </Routes>
    </div>
  );
}
export default App;
